import {
  isEmpty,
  type ProgramUserAddInput,
  type ProgramUserAddSuccess,
  type ProgramUserData,
  toResponseError,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useProgramCache } from './cache'

export function useAddProgramUser(): AddHookResponse<ProgramUserAddInput, ProgramUserData | undefined> {
  const mutation = useTantalimMutation<ProgramUserAddInput, ProgramUserAddSuccess>({
    url: '/program/user/add',
  })
  const cache = useProgramCache()

  async function add(input: ProgramUserAddInput): Promise<ProgramUserData | undefined> {
    try {
      const { programUsers, queued } = await mutation.mutateAsync(input)
      cache.clearUsers(input.programId)
      if (queued) {
        return undefined
      }
      if (isEmpty(programUsers)) {
        throw new Error('User not found')
      }
      return programUsers[0]
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
